/**
 * Shivam Das News Internal Links v2 (Vervado-compatible structure)
 * Europe / DE + EN edition aware
 * - First-occurrence hub + contextual phrase links
 * - Moves Related box into article body when present
 * - Avoids ads, headings, existing links
 */
(function () {
  'use strict';
  if (window.__VERVADO_IL_V2__) return;
  window.__VERVADO_IL_V2__ = true;

  var MAX = 6;
  var path = (location.pathname || '').toLowerCase();
  var isDe = path.indexOf('/blogs/politik-de') >= 0 || path.indexOf('/pages/de') >= 0 ||
             (document.documentElement && document.documentElement.getAttribute('data-sdn-edition') === 'de') ||
             (document.documentElement && (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0);

  // Europe / Shivam hubs (EN + DE phrases)
  var HUBS = [
    // German
    { re: /\bLandtagswahl\b/gi, href: '/blogs/politik-de', title: 'Landtagswahl', blogs: ['politik-de'] },
    { re: /\bBundeskanzler\b/gi, href: '/blogs/politik-de', title: 'Bundeskanzler', blogs: ['politik-de'] },
    { re: /\bSpritpreise?\b/gi, href: '/blogs/politik-de', title: 'Spritpreise', blogs: ['politik-de'] },
    { re: /\bCDU\b/g, href: '/blogs/politik-de', title: 'CDU', blogs: ['politik-de'] },
    { re: /\bAfD\b/g, href: '/blogs/politik-de', title: 'AfD', blogs: ['politik-de'] },
    { re: /\bPolitik\b/gi, href: '/blogs/politik-de', title: 'Politik', blogs: ['politik-de'] },
    { re: /\bDeutschland\b/gi, href: '/pages/de', title: 'Deutschland', blogs: ['*'] },
    // English / US edition hubs on this store
    { re: /\bpolitics\b/gi, href: '/blogs/politics', title: 'Politics', blogs: ['politics'] },
    { re: /\bworld news\b/gi, href: '/blogs/world', title: 'World news', blogs: ['world'] },
    { re: /\bbreaking news\b/gi, href: '/blogs/news', title: 'Breaking news', blogs: ['news'] },
    { re: /\btechnology\b/gi, href: '/blogs/technology', title: 'Technology', blogs: ['technology'] },
    { re: /\bbusiness\b/gi, href: '/blogs/business', title: 'Business', blogs: ['business'] },
    { re: /\bShivam Das News\b/gi, href: isDe ? '/pages/de' : '/', title: 'Shivam Das News', blogs: ['*'] }
  ];

  function onBlog(rule) {
    if (!rule.blogs || rule.blogs.indexOf('*') >= 0) return true;
    for (var i = 0; i < rule.blogs.length; i++) {
      if (path.indexOf('/blogs/' + rule.blogs[i]) >= 0) return true;
    }
    return path.indexOf('/blogs/') >= 0;
  }

  function findArticleRoot() {
    var sels = [
      '.sdn-article-body', '.sdn-article .sdn-article-body',
      '.blog-post-content.rte', '.blog-post-content',
      '.article-template__content', '.article-template .rte',
      '.article__content', '.rte', 'article .rte', 'main .rte'
    ];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el && el.innerText && el.innerText.length > 80) return el;
    }
    return null;
  }

  function isSkip(node) {
    if (!node || node.nodeType !== 1) return true;
    var tag = (node.tagName || '').toLowerCase();
    if (tag === 'a' || tag === 'script' || tag === 'style' || tag === 'code' || tag === 'pre') return true;
    if (tag === 'h1' || tag === 'h2' || tag === 'h3' || tag === 'h4') return true;
    if (node.closest && (node.closest('a') || node.closest('.vervado-ad-slot') || node.closest('.vil-box') || node.closest('.sdn-related'))) return true;
    return false;
  }

  function linkFirst(root, rule) {
    if (!onBlog(rule)) return false;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (isSkip(node.parentElement)) continue;
      var text = node.nodeValue;
      if (!text || text.length < 3) continue;
      rule.re.lastIndex = 0;
      var m = rule.re.exec(text);
      if (!m) continue;
      var start = m.index;
      var end = start + m[0].length;
      var before = text.slice(0, start);
      var match = text.slice(start, end);
      var after = text.slice(end);
      var a = document.createElement('a');
      a.href = rule.href;
      a.title = rule.title;
      a.className = 'sdn-ilink';
      a.textContent = match;
      var parent = node.parentNode;
      if (!parent) continue;
      if (before) parent.insertBefore(document.createTextNode(before), node);
      parent.insertBefore(a, node);
      if (after) parent.insertBefore(document.createTextNode(after), node);
      parent.removeChild(node);
      return true;
    }
    return false;
  }

  function moveRelated(root) {
    var box = document.querySelector('.vil-box, .sdn-related');
    if (!box || !root) return;
    if (root.contains(box)) return;
    try {
      root.appendChild(box);
    } catch (e) {}
  }

  function run() {
    var root = findArticleRoot();
    if (!root) return;
    var n = 0;
    for (var i = 0; i < HUBS.length && n < MAX; i++) {
      if (linkFirst(root, HUBS[i])) n++;
    }
    moveRelated(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
